import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Icon } from '@dnb/eufemia/components';
import { clock_medium } from '@dnb/eufemia/icons';
import { translationKeys } from '@pm-netbank/translations';
import ApplicationRequirementItem from '../../ApplicationRequirementItem/ApplicationRequirementItem';

const MinutesRequirementItem = () => {
  return (
    <ApplicationRequirementItem
      title={
        <FormattedMessage
          id={
            translationKeys.becomeCustomer
              .become_customer_start_application_minutes_title
          }
        />
      }
      message={
        <FormattedMessage
          id={
            translationKeys.becomeCustomer
              .become_customer_start_application_minutes_message
          }
        />
      }
      icon={<Icon icon={clock_medium} />}
    />
  );
};

export default MinutesRequirementItem;
